import { render, staticRenderFns } from "./UserArticleReviewDetail.vue?vue&type=template&id=4a0bbc35&"
import script from "./UserArticleReviewDetail.vue?vue&type=script&lang=js&"
export * from "./UserArticleReviewDetail.vue?vue&type=script&lang=js&"
import style0 from "./UserArticleReviewDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports